import { Search } from 'history';

import { numberHelpers } from '../number';

export const getParamAsNumber = (search: Search, key: string, defaultValue: number): number => {
    const value = numberHelpers.parseNumber(new URLSearchParams(search).get(key));

    return value === undefined ? defaultValue : value;
};
